module.exports = __webpack_public_path__ + "img/img3.40a83f06.png";